interface State {
  isInReview: boolean // 認証作業中
  isAgeAuth: boolean // 年齢認証済み
  isPaymentApplication: boolean // 精算申請中
  applyDate: string
  applyPrice: string
  fee: string
  rewardPoint: string
  payPossiblePoint: number
  priceTable: {}
  mailPT: number
  voiceCallPT: number
  videoCallPT: number
}

const defaultState: State = {
  isInReview: false,
  isAgeAuth: false,
  isPaymentApplication: false,
  applyDate: '',
  applyPrice: '',
  fee: '',
  rewardPoint: '',
  payPossiblePoint: 0,
  priceTable: {},
  mailPT: 0,
  voiceCallPT: 0,
  videoCallPT: 0
}

const state: State = Object.assign({}, defaultState)

const mutations = {
  resetState(state: State) {
    const s = defaultState
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },

  setIsInReview(state: State, isInReview: boolean) {
    state.isInReview = isInReview
  },

  setIsAgeAuth(state: State, isAgeAuth: boolean) {
    state.isAgeAuth = isAgeAuth
  },

  setIsPaymentApplication(state: State, isPaymentApplication: boolean) {
    state.isPaymentApplication = isPaymentApplication
  },

  setApplyDate(state: State, applyDate: string) {
    state.applyDate = applyDate
  },

  setApplyPrice(state: State, applyPrice: string) {
    state.applyPrice = applyPrice
  },

  setFee(state: State, fee: string) {
    state.fee = fee
  },

  setRewardPoint(state: State, rewardPoint: string) {
    state.rewardPoint = rewardPoint
  },

  setPayPossiblePoint(state: State, payPossiblePoint: number) {
    state.payPossiblePoint = payPossiblePoint
  },

  setPriceTable(state: State, priceTable: {}) {
    state.priceTable = priceTable
  },

  setMailPT(state: State, mailPT: number) {
    state.mailPT = mailPT
  },

  setVoiceCallPT(state: State, voiceCallPT: number) {
    state.voiceCallPT = voiceCallPT
  },

  setVideoCallPT(state: State, videoCallPT: number) {
    state.videoCallPT = videoCallPT
  }
}

const actions = {}

const getters = {
  isInReview: (state: State): boolean => state.isInReview,
  isAgeAuth: (state: State): boolean => state.isAgeAuth,
  isPaymentApplication: (state: State): boolean => state.isPaymentApplication,
  applyDate: (state: State): string => state.applyDate,
  applyPrice: (state: State): string => state.applyPrice,
  fee: (state: State): string => state.fee,
  rewardPoint: (state: State): string => state.rewardPoint,
  payPossiblePoint: (state: State): number => state.payPossiblePoint,
  priceTable: (state: State): {} => state.priceTable,
  mailPT: (state: State): number => state.mailPT,
  voiceCallPT: (state: State): number => state.voiceCallPT,
  videoCallPT: (state: State): number => state.videoCallPT
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
